import { getContacts } from '../../api';
import { useListFetch } from '../../hooks';
import type { ContactItem, GetContactsFilters } from '../../api';

export const useContacts = () => {
  return useListFetch<ContactItem, GetContactsFilters>(
    async params => {
      const result = await getContacts(
        params?.filters || {},
        params?.pagination
      );

      return { content: result };
    },
    {
      initialFilters: { campaignId: '', requiresHumanInput: '' },
      withQueryParams: true,
    }
  );
};

export type FormType = ContactItem;
